import React, { FunctionComponent } from "react";
import { featureFlags } from "../../../../Common/CurrentFeatureFlags";
import { ReportH4 } from "../../../Common";
import {
    BreakerBreaker,
    ContentWrap,
    PeepsContainer,
    PeepsContainerSingle,
    PeepsRowContainer,
    PeepsText
} from "./GPSRelVolMetStyles";

interface IGPSRelVolMet {
    location1Name: string;
    location2Name: string;
    location1Color: string;
    location2Color: string;
    loc1Peeps: any[];
    loc2Peeps: any[];
    loc1Vol: string;
    loc2Vol: string;
    loc1CalcPctOfLoc2: string;
    loc2CalcPctOfLoc1: string;
    rh4Title?: string;
}

export const GPSRelVolMetOutput: FunctionComponent<IGPSRelVolMet> = (
    props: IGPSRelVolMet
) => {
    const {
        location1Name,
        location2Name,
        location1Color,
        location2Color,
        loc1Peeps,
        loc2Peeps,
        loc1Vol,
        loc2Vol,
        loc1CalcPctOfLoc2,
        loc2CalcPctOfLoc1,
        rh4Title,
    } = props;

    const isBenchmark = location2Name !== null;

    return (
        loc1Vol
        && (isBenchmark || featureFlags.Mobilytics.newRelativeVolume)
        && <>
            {rh4Title && <ReportH4>{rh4Title}</ReportH4>}
            <p style={{ fontSize: "17px" }}>
                Compares visit volume at {location1Name} to {location2Name ? location2Name : "to comparable businesses in the area"}.
            </p>
            <ContentWrap>
                {loc2Vol ? <PeepsContainer className="left-side">
                    {
                        featureFlags.Mobilytics.newRelativeVolume
                            ? <PeepsText>
                                <span style={{ color: location1Color }}>{location1Name}</span>{" "}
                                Estimated Volume is {loc1Vol}{" "}
                                (<span style={{ fontWeight: "bold" }}>{loc1CalcPctOfLoc2}%</span>) of{" "}
                                {location2Name}.
                            </PeepsText>
                            : <PeepsText>
                                <span style={{ color: location1Color }}>{location1Name}</span>{" "}
                                {`Volume is `}
                                <span style={{ fontWeight: "bold" }}>{loc1CalcPctOfLoc2}%</span> of{" "}
                                {location2Name}.
                            </PeepsText>
                    }
                    {loc1Peeps.map((peepRow, i) => {
                        return (
                            <PeepsRowContainer key={`loc1PeepsRow-${i}`}>
                                {peepRow}
                            </PeepsRowContainer>
                        );
                    })}
                </PeepsContainer>
                    : <PeepsContainerSingle className="left-side">
                        <PeepsText>
                            <span style={{ textAlign: "center" }}>{location1Name}</span>{" "}
                            Estimated Volume is {loc1Vol}
                        </PeepsText>
                        {loc1Peeps.map((peepRow, i) => {
                            return (
                                <PeepsRowContainer key={`loc1PeepsRow-${i}`}>
                                    {peepRow}
                                </PeepsRowContainer>
                            );
                        })}
                    </PeepsContainerSingle>}
                {loc2Vol && <><BreakerBreaker></BreakerBreaker>
                    <PeepsContainer>
                        {
                            featureFlags.Mobilytics.newRelativeVolume
                                ? <PeepsText>
                                    <span style={{ color: location2Color }}>{location2Name}</span>{" "}
                                    Estimated Volume is {loc2Vol}{" "}
                                    (<span style={{ fontWeight: "bold" }}>{loc2CalcPctOfLoc1}%</span>) of{" "}
                                    {location1Name}.
                                </PeepsText>
                                : <PeepsText>
                                    <span style={{ color: location2Color }}>{location2Name}</span>{" "}
                                    {`Volume is `}
                                    <span style={{ fontWeight: "bold" }}>{loc2CalcPctOfLoc1}%</span> of{" "}
                                    {location1Name}.
                                </PeepsText>
                        }
                        {loc2Peeps.map((peepRow, i) => {
                            return (
                                <PeepsRowContainer key={`loc2PeepsRow-${i}`}>
                                    {peepRow}
                                </PeepsRowContainer>
                            );
                        })}
                    </PeepsContainer></>}
            </ContentWrap>
        </>
    );
};
